import { atomWithReset } from 'jotai/utils';

import { type BannerFilters, INITIAL_BANNER_FILTERS } from '../../types/bannerFilters';

/**
 * Átomo com o estado dos filtros (server-side) **já aplicados** da listagem de
 * Banner. O estado pendente (o que o operador está montando na barra de filtros)
 * vive local em `BannerFilterBar` e só chega aqui ao acionar "Pesquisar".
 *
 * Deve ser consumido apenas via `useBannerFilters` (CLAUDE.md proíbe `useAtom`
 * direto em componentes). Resetável via `useResetAtom`.
 */
export const bannerFiltersAtom = atomWithReset<BannerFilters>(INITIAL_BANNER_FILTERS);
